import React from 'react';
import {
  AntdConfigProvider,
  Tabs
} from 'syngenta-digital-cropwise-react-ui-kit';
import './index.css';

type TabProps = {
  label: string;
  disabled?: boolean;
  children?: React.ReactNode;
};

// Only a marker: UiKitTabs reads its props and never renders it.
const Tab: React.FC<TabProps> = () => null;

type UiKitTabsProps = {
  children: React.ReactNode;
};

/**
 * The detail panels' tab strip, written as `<UiKitTabs.Tab label>`
 * children like the grow-ui Tabs it replaces.
 */
const UiKitTabs = ({ children }: UiKitTabsProps) => {
  const items = React.Children.toArray(children)
    .filter((child): child is React.ReactElement<TabProps> =>
      React.isValidElement(child)
    )
    .map(({ props: { label, disabled, children: content } }) => ({
      key: label,
      label,
      disabled,
      children: <div className="cwf-kit-tabs__panel">{content}</div>
    }));

  return (
    // The kit re-exports antd's Tabs without its prefix provider, which would
    // otherwise render unstyled `ant-` classes.
    <div className="cwf-kit-tabs">
      <AntdConfigProvider>
        {/* grow-ui unmounted inactive panels; several fetch on mount. */}
        <Tabs items={items} destroyInactiveTabPane />
      </AntdConfigProvider>
    </div>
  );
};

UiKitTabs.Tab = Tab;

export default UiKitTabs;
